var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXppay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 210,
    r: 210,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 210,
    r: 210,
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.179 199.424L232.25 220.878C217.592 224.191 202.379 224.191 187.721 220.878L92.7917 199.424C82.917 197.192 76.1063 187.875 78.4711 178.031C92.6832 118.872 146.186 75 209.985 75C273.784 75 327.287 118.872 341.499 178.031C343.864 187.875 337.053 197.192 327.179 199.424ZM81.7059 251.707C79.5759 245.38 84.844 239.339 91.5004 239.853L209.751 248.987C210.265 249.026 210.781 249.026 211.294 248.986L328.595 239.89C335.372 239.364 340.72 245.626 338.576 252.078C337.805 254.399 336.974 256.69 336.072 258.946C334.717 262.336 331.461 264.527 327.818 264.765L210.254 272.449L92.6892 264.765C89.0466 264.527 85.7921 262.336 84.4089 258.958C83.4345 256.578 82.5314 254.159 81.7059 251.707ZM163.609 326.785C158.434 326.785 156.951 333.144 161.783 334.995C176.778 340.742 192.973 344.001 209.984 344.001C227.204 344.001 243.727 340.801 258.855 334.9C263.635 333.035 262.136 326.785 257.004 326.785H163.609ZM120.258 288.738L209.983 291.817L299.709 288.738C307.952 288.455 312.672 297.519 306.886 303.396C305.584 304.719 304.256 306.013 302.907 307.277C301.12 308.952 298.745 309.84 296.296 309.84H123.67C121.221 309.84 118.847 308.952 117.06 307.277C115.711 306.013 114.383 304.719 113.081 303.396C107.295 297.519 112.015 288.455 120.258 288.738Z",
    fill: "url(#paint1_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 422,
    height: 425,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 63,
    y: 74,
    width: 287.97,
    height: 293.001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.325 378.426) rotate(-54.1098) scale(392.768 546.698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A32CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311607,
    stopColor: "#9E00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE453D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.984 83.5) rotate(70.2085) scale(293.858 288.362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7901A4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXppay);
export default __webpack_public_path__ + "static/media/xppay.73e5aaabbb5775e5a177764902ee2e20.svg";
export { ForwardRef as ReactComponent };